// import {findIndex, equals, isNil} from 'ramda'
import vue from 'vue'

const appStore = {
  state: {
    sidebarCollapse: true,
    tagsContainer: {},
    permissionRoutes: []
  },
  mutations: {
    setSidebarCollapse: (state, collapse) => {
      state.sidebarCollapse = collapse
    },
    DELETE_TAG: (state, tag) => {
      const { name } = tag

      vue.delete(state.tagsContainer, name)
    },
    ADD_TAG: (state, tag) => {
      const { name } = tag
      // 默认主页标签
      if (
        state.tagsContainer['welcome'] === null ||
        state.tagsContainer['welcome'] === undefined
      ) {
        vue.set(state.tagsContainer, 'welcome', { path: '/welcome', name: 'welcome', meta: { title: '首页', icon: require('@/assets/icon/home.png'), affix: true }})
      }
      if (
        state.tagsContainer[name] === null ||
        state.tagsContainer[name] === undefined
      ) {
        vue.set(state.tagsContainer, name, tag)
      }
    },
    SET_PERMISSION_ROUTES: (status, routes) => {
      status.permissionRoutes = routes
    }
  },
  actions: {
    addOneTagToContainer: ({ commit, state }, tag) => {
      const { name } = tag

      commit('ADD_TAG', tag)

      return Object.keys(state.tagsContainer).findIndex(item => item === name)
    },
    deleteOneTagFromContainer: ({ commit }, tag) => {
      commit('DELETE_TAG', tag)
    },
    getPermissionRoutes: ({ commit }, routes) => {
      commit('SET_PERMISSION_ROUTES', routes)
    }
  }
}

export default appStore



// WEBPACK FOOTER //
// ./src/store/module/appStore.js